import { BrandEntry } from '../types';

export async function loadBrandConfig(slug: string): Promise<BrandEntry | null> {
  try {
    const res = await fetch('/brands.json');
    const brands: Record<string, BrandEntry> = await res.json();
    return brands[slug] ?? null;
  } catch {
    return null;
  }
}
